import { Checkbox, CheckboxProps, SxProps, Theme } from '@mui/material';
import { ReactComponent as DefaultCheckboxIcon } from 'assets/icons/checkbox/default-checkbox.svg';
import { ReactComponent as CheckboxIcon } from 'assets/icons/checkbox/checkbox.svg';

export type BaseCheckboxProps = Omit<CheckboxProps, 'sx'> & {
    sx?: SxProps<Theme>;
};

const BaseCheckbox = ({ sx, ...rest }: BaseCheckboxProps) => {
    return (
        <Checkbox
            sx={{ ...sx, padding: '0' }}
            icon={<DefaultCheckboxIcon />}
            checkedIcon={<CheckboxIcon />}
            {...rest}
        />
    );
};

export default BaseCheckbox;
